<div *ngIf="category" class="shadow-lg p-3 rounded-lg card card-profile" [routerLink]="[
    APP_ROUTES.PRIVATE.DASHBOARD.HOME_CHILDS.SUB_CATEGORY,
    isDemo ? '1999' : category?.id
  ]">
  <!-- Card Header -->
  <div class="d-flex align-items-center card-header">
    <div class="card-image-wrapper">
      <img class="rounded-circle card-image" [src]="BASE_API + category?.attachment?.filename" alt="Category Image" />
    </div>
    <div class="ms-3 text-right card-title-wrapper">
      <h5 class="text-primary card-title fw-bold">{{ category?.name }}</h5>
    </div>
  </div>

  <!-- Chart Section -->
  <div *ngIf="showChart && !isSameDay" class="mt-4 chart-wrapper">
    <apx-chart #muuuuu [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
      [stroke]="chartOptions.stroke" [dataLabels]="chartOptions.dataLabels" [yaxis]="chartOptions.yaxis"
      [labels]="chartOptions.labels" [title]="chartOptions.title"
      [colors]="['#5ba556', '#42c425', '#7bf96d']"></apx-chart>
  </div>

  <!-- Footer Section -->
  <div class="mt-4 card-footer">
    <div class="d-flex justify-content-between price-container">
      <!-- Lowest Price -->
      <div class="price-box">
        <h6 class="price-label">الأقل سعر / كلغ</h6>
        <div class="text-success price-value">
          <ng-container *ngIf="category?.productsLowestPrice !== null; else loader">
            <span><span class="icon-saudi_riyal">&#xea;</span></span> {{ category?.productsLowestPrice || '0' }}
          </ng-container>
          <ng-template #loader>
            <div class="loader"></div> <!-- Replace with your loader design -->
          </ng-template>
        </div>

      </div>

      <!-- Highest Price -->
      <div class="price-box">
        <h6 class="price-label">أعلى سعر / كلغ</h6>
        <div class="text-danger price-value">
          <ng-container *ngIf="category?.productsHighestPrice !== null; else loader2">
            <span><span class="icon-saudi_riyal">&#xea;</span></span> {{ category?.productsHighestPrice || '0' }}
          </ng-container>
          <ng-template #loader2>
            <div class="loader2"></div> <!-- Replace with your loader design -->
          </ng-template>
        </div>
        
      </div>
    </div>
  </div>
</div>